import { addWagesQueryParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addWegas/addWegesQuery.type';
import { AddWegasQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addWegas/addWegesQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const useAddWagesQueryOption = () => {
  return useMutation({
    mutationFn: (params: addWagesQueryParams) => AddWegasQueryFunction(params),
    mutationKey: ['addWagesQueryOption'],
  });
};
